function isStatusbarEntryLocation(thing) {
    const candidate = thing;
    return typeof candidate?.id === 'string' && typeof candidate.alignment === 'number';
}
function isStatusbarEntryPriority(thing) {
    const candidate = thing;
    return (typeof candidate?.primary === 'number' || isStatusbarEntryLocation(candidate?.primary)) && typeof candidate?.secondary === 'number';
}
const ShowTooltipCommand = {
    id: 'statusBar.entry.showTooltip',
    title: ''
};
const StatusbarEntryKinds = ['standard', 'warning', 'error', 'prominent', 'remote', 'offline'];
export { ShowTooltipCommand, StatusbarEntryKinds, isStatusbarEntryLocation, isStatusbarEntryPriority };
